/**CORE LIBRARIES IMPORT */
import React from "react";

/**
 * Crescent and star from the Turkish flag, using the official proportions
 * (Turkish Flag Law: crescent outer/inner circles G/4 and G/5, offset G/16).
 * Coordinates follow the common 90000×60000 reference drawing, cropped to the
 * emblem. Decorative only.
 */
const TurkishEmblem = ({ className = "" }) => (
  <svg
    className={`turkish-emblem ${className}`}
    viewBox="15000 -15500 41500 31000"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="m41750 0 13568-4408-8386 11541V-7133l8386 11541zm925 8021a15000 15000 0 1 1 0-16042 12000 12000 0 1 0 0 16042z"
    />
  </svg>
);

export default TurkishEmblem;
